export default __webpack_public_path__ + "static/Dan_Ashlock-8883955f3fccb39a235ebe4492bac9a3.jpg";